import { render, staticRenderFns } from "./OurActionButton.vue?vue&type=template&id=031e2490&"
import script from "./OurActionButton.vue?vue&type=script&lang=js&"
export * from "./OurActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports